import {
    Box,
    Card,
    Skeleton,
    Stack,
    Typography
} from "@mui/material";
import React from "react";
import { textPrimary } from "../../constants/colors";

interface ICardLaporanKalkulasiProps {
    namaCard: string;
    isiCard: string;
    icon: React.ReactNode;
    isLoading?: React.ReactNode;
}

const CardLaporanKalkulasi = ({
    namaCard,
    isiCard,
    icon,
    isLoading,
}: ICardLaporanKalkulasiProps) => {
    return (
        <Card
            variant="outlined"
            sx={{
                display: "flex",
                alignItems: "center",
                paddingY: 1,
                width: "100%",
            }}
        >
            <Box display="flex" alignItems="center" marginLeft={3}>
                <Box
                    sx={{
                        position: "relative",
                        // bgcolor: "primary.light",
                        bgcolor: "white",
                        // filter: "brightness(300%)",
                        width: 60,
                        height: 60,
                        border: `1px solid ${textPrimary.thin}`,
                        borderRadius: "50%",
                        marginRight: 4,
                    }}
                >
                    {icon}
                </Box>
                <Box justifyContent="space-between">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="subtitle2">{namaCard}</Typography>
                    </Stack>
                    {isLoading ? null : (
                        <Typography fontSize={18} fontWeight="bold">
                            {isiCard}
                        </Typography>
                    )}
                    {isLoading ? (
                        <Skeleton variant="text" sx={{ fontSize: 18 }} />
                    ) : null}
                </Box>
            </Box>
        </Card>
    );
};

export default CardLaporanKalkulasi;
